import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'biz-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit {

  @Input() title: string;
  @Input() subtitle: string;
  @Input() content: string;
  @Input() isCollapsed: boolean = true;
  @Output() isOpen = new EventEmitter<boolean>();
  
  constructor() { }

  ngOnInit() {
  }

  isAccordionOpened() {
    this.isOpen.emit(true);
  }

}
